import { render, staticRenderFns } from "./ConfirmationEticket.vue?vue&type=template&id=52f63ed4&"
import script from "./ConfirmationEticket.vue?vue&type=script&lang=js&"
export * from "./ConfirmationEticket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports